export const START_AUCTION_DATE_STRING = 'June 4, 2021 18:00:00 GMT+0700'
export const END_AUCTION_DATE_STRING = 'June 7, 2021 18:00:00 GMT+0700'
export const END_AUCTION_REDIRECT_DATE_STRING = 'June 7, 2021 19:00:00 GMT+0700'